import React, { useContext, useEffect, useState } from 'react';
import './Footer.scss';
import { classNameBuilder } from '../../../utils/className';
import Button from '../../Button/Button';
import Container from '../../Container/Container';
import { socialService } from '../../../services/socialService';
import Typography from '../../Typography/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';

interface IProps {}

const Footer: React.FC<IProps> = () => {
    const cn = classNameBuilder('footer');

    const [socialLinks, setSocialLicks] = useState<any[]>([]);

    const navigate = useNavigate();
    const location = useLocation();

    const { user } = useContext(AuthContext);
    const linkToLK = user ? `/cabinet/${user.id}/` : `/login`;

    const refresh = () => {
        socialService
            .getAll()
            .then((response) => {
                setSocialLicks(
                    response.data.result
                        .sort((a: any, b: any) => a.position - b.position)
                        .filter(
                            (value: any) =>
                                !!value.url &&
                                !!value.title &&
                                !!value.attachmentUid &&
                                !!value.active,
                        ),
                );
            })
            .catch((err) => {
                // console.log(err)
            });
    };

    useEffect(() => refresh(), []);

    return (
        <div className={cn('')}>
            <Container type="default">
                <div className={cn('body')}>
                    <div className={cn('list_container')}>
                        <div className={cn('list')}>
                            <Typography variant={'h3'}>Разделы</Typography>
                            <ul>
                                <li>
                                    <a href={linkToLK}>Личный кабинет</a>
                                </li>
                                <li>
                                    <a href={'/vacancies'}>Вакансии</a>
                                </li>
                                <li>
                                    <a href={'/internships'}>Стажировки</a>
                                </li>
                                <li>
                                    <a href={'/education'}>Образование</a>
                                </li>
                                <li>
                                    <a href={'/contacts'}>Контакты</a>
                                </li>
                                <li>
                                    <a href={'/help'}>Помощь</a>
                                </li>
                            </ul>
                        </div>
                        <div className={cn('list')}>
                            <Typography variant={'h3'}>Полезные ссылки</Typography>
                            <ul>
                                <li>
                                    <a href="https://biocad.ru/" target={'_blank'} rel="noreferrer">
                                        Официальный сайт BIOCAD
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://master-spcpu.biocad.ru/"
                                        target={'_blank'}
                                        rel="noreferrer">
                                        Магистратура СПФХУ
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://hse.biocad.ru/"
                                        target={'_blank'}
                                        rel="noreferrer">
                                        Магистратура ВШЭ
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={cn('contact-us')}>
                        {socialLinks[0] && (
                            <div className={cn('social')}>
                                <Typography variant={'h3'}>Мы на связи</Typography>
                                <div className={cn('social-row')}>
                                    {socialLinks.map((value, index) => (
                                        <a
                                            key={index}
                                            href={value.url}
                                            target={'_blank'}
                                            rel="noreferrer">
                                            <img
                                                src={`${process.env.REACT_APP_API_URL}/api/v1/attachment/${value.attachmentUid}`}
                                                alt="social-icon"
                                            />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className={cn('contact-us-buttons')}>
                            <Button
                                onClick={() =>
                                    navigate('/ask-question', {
                                        state: { previousPath: location.pathname },
                                    })
                                }>
                                Задать вопрос
                            </Button>
                            <Button
                                onClick={() =>
                                    navigate('/report-error', {
                                        state: { previousPath: location.pathname },
                                    })
                                }>
                                Сообщить об ошибке
                            </Button>
                        </div>
                    </div>
                </div>
                <div className={cn('foot')}>
                    <span className={cn('foot--left')}>
                        © {new Date().getFullYear()} Все права на материалы сайта принадлежат
                        компании АО «БИОКАД».
                    </span>
                    <div className={cn('foot--right')}>
                        <a
                            href={'/policy/PROCESSING_PERSONAL_DATA'}
                            target={'_blank'}
                            rel="noreferrer">
                            <span>Политика по обработке ПД</span>
                        </a>
                        <a href={'/policy/USE_COOKIES'} target={'_blank'} rel="noreferrer">
                            <span>Политика Cookies</span>
                        </a>
                        <a href={'/policy/AGREEMENT_USE_SITE'} target={'_blank'} rel="noreferrer">
                            <span>Условия использования Сайта</span>
                        </a>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Footer;
